import { render, staticRenderFns } from "./TestimonialList.vue?vue&type=template&id=97e5479c&scoped=true&"
import script from "./TestimonialList.vue?vue&type=script&lang=ts&"
export * from "./TestimonialList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e5479c",
  null
  
)

export default component.exports